import Track from './Track';

function trackLabel(options) {
  return label => Track.event({ ...options, label });
}

export default trackLabel;
